export default __webpack_public_path__ + "static/media/sad.2aa4c7da.png";